var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 137.483C120.711 137.483 137.5 120.694 137.5 99.9834C137.5 79.2727 120.711 62.4834 100 62.4834C79.2893 62.4834 62.5 79.2727 62.5 99.9834C62.5 120.694 79.2893 137.483 100 137.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 62.4999H164.941C158.361 51.098 148.894 41.6296 137.493 35.0468C126.093 28.464 113.16 24.9988 99.9952 24.9998C86.8305 25.0007 73.8981 28.4676 62.4983 35.052C51.0985 41.6364 41.6333 51.1061 35.0542 62.509L67.5248 118.75L67.5539 118.742C64.2508 113.046 62.5076 106.58 62.5002 99.9957C62.4928 93.4112 64.2214 86.9412 67.5117 81.2377C70.802 75.5343 75.5378 70.799 81.2416 67.5093C86.9454 64.2197 93.4157 62.4918 100 62.4999Z",
    fill: "url(#paint0_linear_604_1160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 129.687C116.396 129.687 129.687 116.396 129.687 100C129.687 83.604 116.396 70.3125 100 70.3125C83.604 70.3125 70.3125 83.604 70.3125 100C70.3125 116.396 83.604 129.687 100 129.687Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.473 118.759L100.002 175C113.167 175.002 126.1 171.538 137.501 164.956C148.902 158.374 158.369 148.906 164.951 137.505C171.532 126.103 174.996 113.17 174.994 100.005C174.991 86.8408 171.523 73.9088 164.938 62.5098H99.9966L99.9888 62.5388C106.573 62.5261 113.045 64.2495 118.751 67.5353C124.457 70.8211 129.196 75.5532 132.49 81.2544C135.784 86.9556 137.517 93.4246 137.514 100.009C137.511 106.594 135.772 113.061 132.473 118.759Z",
    fill: "url(#paint1_linear_604_1160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.527 118.76L35.0564 62.5188C28.4724 73.9188 25.0059 86.8513 25.0054 100.016C25.0049 113.181 28.4704 126.113 35.0536 137.514C41.6367 148.914 51.1054 158.381 62.5075 164.961C73.9096 171.541 86.8433 175.004 100.008 175L132.479 118.759L132.458 118.738C129.176 124.446 124.448 129.189 118.749 132.488C113.051 135.786 106.583 137.524 99.9986 137.527C93.4141 137.529 86.9454 135.795 81.2446 132.5C75.5437 129.206 70.8122 124.466 67.527 118.76Z",
    fill: "url(#paint2_linear_604_1160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_1160",
    x1: 35.0542,
    y1: 71.8749,
    x2: 164.941,
    y2: 71.8749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_1160",
    x1: 89.756,
    y1: 173.997,
    x2: 154.7,
    y2: 61.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_1160",
    x1: 108.119,
    y1: 170.317,
    x2: 43.1754,
    y2: 57.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.35d106731d4719f3aed28e59acd36867.svg";
export { ForwardRef as ReactComponent };